import {Component, computed, OnDestroy} from '@angular/core';
import {PinholeUploaderService, UploadType} from "../services/pinhole.uploader.service";
import {startWith, Subscription} from "rxjs";
import {FormBuilder, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {HttpErrorResponse} from "@angular/common/http";
import {CustomDropzoneComponent} from "./dropzone/custom-dropzone.component";
import {AlertComponent} from "../../../common/alert/alert.component";
import {AlertService} from "../../../common/alert/alert.service";
import {toSignal} from "@angular/core/rxjs-interop";

@Component({
    selector: 'upload',
    templateUrl: './upload.component.html',
    imports: [
        ReactiveFormsModule,
        CustomDropzoneComponent,
        AlertComponent
    ],
    providers: [AlertService]
})
export class UploadComponent implements OnDestroy {
    private subscriptions: Subscription[] = [];
    private formBuilder = new FormBuilder().nonNullable
    private installIdOrLogin = this.formBuilder.control("")
    private uploadType = this.formBuilder.control(UploadType.Round)
    private uploadTypeValue = toSignal(this.uploadType.valueChanges.pipe(startWith(this.uploadType.value)));

    installIdOrLoginLabel = computed(() => {
        switch (this.uploadTypeValue()!) {
            case UploadType.Round:
                return "Install id:"
            case UploadType.Snapshot:
                return "Login:"
        }
    })

    isLoading: boolean = false;
    file: File | undefined;
    loadForm = new FormGroup({
        installIdOrLogin: this.installIdOrLogin,
        uploadType: this.uploadType
    });

    constructor(private service: PinholeUploaderService, private alertService: AlertService) {

    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe())
    }

    onFileSelected(file: File) {
        this.file = file;
    }

    upload() {
        this.alertService.clearAlerts();
        this.isLoading = true;
        if (this.file) {
            this.subscriptions.push(
                this.service.upload(this.installIdOrLogin.value, this.file, this.uploadTypeValue()!).subscribe({
                    next: () => {
                        this.alertService.showAlert('success', "Success loading");
                        this.isLoading = false;
                    },
                    error: (result: HttpErrorResponse) => {
                        this.alertService.showAlert('danger', "Error loading!");
                        this.isLoading = false;
                    }
                }))
        } else {
            this.alertService.showAlert('danger', "Not file");
        }
    }

    protected readonly UploadType = UploadType;
}
